import {useEffect, useRef, useState} from 'react';
import s from './capability.module.less';

export default function CapabilityModel({model}) {
    const [selected, setSelected] = useState(0);
    const tabRefs = useRef([]);
    const sectionRef = useRef(null);
    useEffect(() => {
        if (window.location.hash !== '#capability-model') return;
        const frame = requestAnimationFrame(() => sectionRef.current?.scrollIntoView({block: 'start'}));
        return () => cancelAnimationFrame(frame);
    }, []);
    const active = model.dimensions[selected];
    const connections = ['M50 50 L18 15', 'M50 50 L82 15', 'M50 50 L18 50', 'M50 50 L82 50', 'M50 50 L18 85', 'M50 50 L82 85'];
    const onTabKeyDown = (event, index) => {
        const count = model.dimensions.length;
        const next = {ArrowRight: (index + 1) % count, ArrowLeft: (index - 1 + count) % count, Home: 0, End: count - 1}[event.key];
        if (next === undefined) return;
        event.preventDefault();
        setSelected(next);
        tabRefs.current[next]?.focus();
    };
    const revealEvidence = (event) => {
        const target = document.querySelector(event.currentTarget.getAttribute('href'));
        if (!target) return;
        // Open the overview before native anchor navigation measures its position.
        const overview = target.closest('details');
        if (overview) overview.open = true;
    };

    return <section ref={sectionRef} className={s.model} id='capability-model' aria-labelledby='capability-heading'>
        <header className={s.header}>
            <p>{model.title}</p>
            <h2 id='capability-heading'>{model.headline}</h2>
            <p className={s.intro}>{model.intro}</p>
        </header>
        <div className={s.workspace}>
            <div className={s.map} role='tablist' aria-label='负责人能力维度'>
                <svg className={s.connections} viewBox='0 0 100 100' preserveAspectRatio='none' aria-hidden='true'>
                    {connections.map((path, index) => <path key={path} d={path} className={index === selected ? s.connectionActive : ''}/>)}
                </svg>
                <div className={s.core} aria-hidden='true'><span>AI 产研</span><strong>技术统筹</strong><small>目标 · 体系 · 结果</small></div>
                {model.dimensions.map((dimension, index) => <button
                    key={dimension.id}
                    ref={(node) => { tabRefs.current[index] = node; }}
                    type='button'
                    role='tab'
                    id={`capability-tab-${dimension.id}`}
                    className={s.node}
                    style={{'--node-x': index % 2 ? '82%' : '18%', '--node-y': `${15 + Math.floor(index / 2) * 35}%`}}
                    aria-selected={selected === index}
                    aria-controls={`capability-panel-${dimension.id}`}
                    tabIndex={selected === index ? 0 : -1}
                    onClick={() => setSelected(index)}
                    onKeyDown={(event) => onTabKeyDown(event, index)}
                >
                    <strong>{dimension.short}</strong>
                    <span>{dimension.subtitle}</span>
                </button>)}
            </div>
            <div className={s.detail} role='tabpanel' id={`capability-panel-${active.id}`} aria-labelledby={`capability-tab-${active.id}`} tabIndex={0}>
                <div key={active.id} className={s.detailContent}>
                    <h3>{active.name}</h3>
                    <p className={s.description}>{active.description}</p>
                    <div className={s.decision}><span>关键判断</span><p>{active.decision}</p></div>
                    <ul className={s.mechanisms}>{active.mechanisms.map((action) => <li key={action}>{action}</li>)}</ul>
                    <div className={s.evidence}><strong>{active.result}</strong><p>{active.context}</p></div>
                    <div className={s.links}>{active.links.map((item) => <a key={item.href} href={item.href} onClick={revealEvidence}>{item.label}<span aria-hidden='true'> ↗</span></a>)}</div>
                </div>
            </div>
        </div>
    </section>;
}
